<template>
  <pt-branch-company-detail class="pt-branch-company-detail__page"></pt-branch-company-detail>
</template>

<script>
import PtBranchCompanyDetail from 'cps//branch-company-manage/pt-branch-company-detail/withData'
export default {
  name: 'pt-branch-company-detail__view',
  components: {
    'pt-branch-company-detail': PtBranchCompanyDetail
  }
}
</script>
